import { widthCard } from "../constants";

export const cardsInRow = (screen: number) => {
  let cardsinRow = 2;
  if (screen < widthCard * 3) {
    cardsinRow = 2;
  } else if (screen < widthCard * 4) {
    cardsinRow = 4;
  } else if (screen < widthCard * 5) {
    cardsinRow = 5;
  } else if (screen < widthCard * 6) {
    cardsinRow = 6;
  } else {
    cardsinRow = 6;
  }
  return cardsinRow;
};

export const cardWidth = (screen: number) => {
  const cardsinRow = cardsInRow(screen);
  const width = (screen - 0.5) / cardsinRow;
  return width;
};
